import { UPDATE_GOALS_SEARCH_RESULTS } from "actions/constants";

const initialState = {};

const goalsSearchResults = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_GOALS_SEARCH_RESULTS: {
      const { searchResults } = action.payload;

      // Convert array of goals to object with goal.id as key
      const searchResultsObject = searchResults.reduce((acc, goal) => {
        acc[goal.id] = goal;
        return acc;
      }, {});

      return {
        ...searchResultsObject,
      };
    }

    default:
      return state;
  }
};

export default goalsSearchResults;
